export const RESET = 'USERDATAADDRESS_LIST_RESET'
export const SET_ITEMS = 'USERDATAADDRESS_LIST_SET_ITEMS'
export const SET_ERROR = 'USERDATAADDRESS_LIST_SET_ERROR'
export const SET_VIEW = 'USERDATAADDRESS_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'USERDATAADDRESS_LIST_TOGGLE_LOADING'
